import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=746ee076&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&lang=ts"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=746ee076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ee076",
  null
  
)

export default component.exports